import 'bootstrap/dist/css/bootstrap.min.css'

import '../css/main.css'

import './icons'

import { prepareForm } from './form-util'
prepareForm()
